import * as React from 'react'

import { Box, type Colors, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { MaxOptionLabelLength } from 'modules/custom_resources/store/collections/customFields/fields'

type TextFieldProps = React.ComponentProps<typeof TextField>

interface Props {
  label: string
  disabled: boolean
  onChange: TextFieldProps['onChange']
  archived: boolean
  draft: boolean
}

const ArchivedTag = ({ archived }: { archived: boolean }) => {
  if (!archived) return null

  return (
    <Tag type={Tag.Types.grey}>
      {i18n.t('settings.custom_fields.new.labels.single_choice_options.archived')}
    </Tag>
  )
}

const Item = ({ archived, color, label }: { archived: boolean; color: Colors; label: string }) => {
  return (
    <Box
      background="grey200"
      padding="s12"
      flexGrow
      borderRadius={{
        all: 'abs004',
      }}
    >
      <Text.Normal color={color}>
        {label}
        <Box paddingLeft="s16">
          <ArchivedTag archived={archived} />
        </Box>
      </Text.Normal>
    </Box>
  )
}

const Input = ({ label, onChange, archived, draft }: Props) => {
  if (draft) {
    const error =
      label.length > MaxOptionLabelLength &&
      i18n.t('settings.custom_fields.new.labels.single_choice_options.too_long', {
        max_number: MaxOptionLabelLength,
      })

    return (
      <TextField
        value={label}
        placeholder={i18n.t('settings.custom_fields.new.labels.single_choice_options.placeholder')}
        onChange={onChange}
        error={error || undefined}
      />
    )
  }

  const color = archived ? 'grey800' : 'grey1000'

  return <Item archived={archived} color={color} label={label} />
}

export default observer(Input)
